import styles from '@features/categories/components/CategoriesProductsCount/CategoriesProductsCount.styles';
import useInflectedTranslation from '@hooks/useInflectedTranslation';
const ProductsCount = ({
  productsLength,
  align
}: {
  productsLength: number;
  align: string | null;
}) => {
  const {
    getInflectedTranslation
  } = useInflectedTranslation();
  return <span sx={styles.productCountAlign(align)} data-cy="ProductsCount">
      {productsLength} {getInflectedTranslation(productsLength, 'products')}
    </span>;
};
export default ProductsCount;